import { StandingEntry } from "@/hooks/useStandingsCache";
import { StandingsTable } from "./StandingsTable";

interface StandingsTableGroupedProps {
  groupedStandings: StandingEntry[][];
  leagueName?: string;
  leagueApiId?: number;
  season?: number;
  className?: string;
  leagueLogo?: string;
  highlightTeamIds?: number[];
}

export function StandingsTableGrouped({
  groupedStandings,
  leagueName,
  leagueApiId,
  season = 2025,
  className,
  leagueLogo,
  highlightTeamIds,
}: StandingsTableGroupedProps) {
  return (
    <div className="space-y-6">
      {groupedStandings.map((standings, index) => {
        const groupLabel =
          standings?.[0]?.group ?? `Group ${String.fromCharCode(65 + index)}`;

        return (
          <div key={index} className="space-y-2">
            <h3 className="text-lg font-bold text-foreground px-2">
              {leagueName ? `${leagueName} — ` : ''}{groupLabel}
            </h3>
            <StandingsTable
              standings={standings}
              leagueApiId={leagueApiId}
              season={season}
              className={className}
              leagueLogo={leagueLogo}
              highlightTeamIds={highlightTeamIds}
            />
          </div>
        );
      })}
    </div>
  );
}
